$(document).on(
  "revelation__s27_float_top rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
  }
);
